import { Injectable } from '@angular/core';
import { ApiServiceBase } from '@api/abstracts';
import { LocalizedCommon } from './models';

@Injectable({
  providedIn: 'root',
})
export class CommonService extends ApiServiceBase<LocalizedCommon> {
  constructor() {
    super('common');
  }
}
